import { z } from 'zod';
import { ConversationMessageContentType } from '@/models/conversations/conversation';

export enum SendMessageCommand {
  HeartBeat = 'HeartBeat',
  Login = 'Login',
  Logout = 'Logout',
  Chat = 'Chat',
  DeleteChat = 'DeleteChat',
  GroupChat = 'GroupChat',
  GroupUnsubscribe = 'UnSubscribe',
  DeleteGroupChat = 'DeleteGroupChat',
  GroupInvite = 'Invite',
  Basic = 'Basic',
}

export const sendChatMessageScheme = z.object({
  Cmd: z.literal(SendMessageCommand.Chat),
  ChatSessionID: z.number(),
  MsgType: z.lazy(() => z.nativeEnum(ConversationMessageContentType)),
  UserID: z.number(),
  QuoteChatID: z.number().optional(),
  Message: z.string().min(1),
  TimeStamp: z.number().int(),
});

export const sendGroupChatMessageScheme = z.object({
  Cmd: z.literal(SendMessageCommand.GroupChat),
  GroupID: z.number(),
  MsgType: z.lazy(() => z.nativeEnum(ConversationMessageContentType)),
  UserID: z.number(),
  QuoteGroupChatID: z.number().optional(),
  Message: z.string().min(1),
  TimeStamp: z.number().int(),
  AtIDs: z.string().nullable(),
});

export const deleteChatMessageScheme = z.object({
  Cmd: z.literal(SendMessageCommand.DeleteChat),
  ChatID: z.number(),
  UserID: z.number(),
  ChatSessionID: z.number(),
});

export const deleteGroupChatMessageScheme = z.object({
  Cmd: z.literal(SendMessageCommand.DeleteGroupChat),
  GroupChatID: z.number(),
  UserID: z.number(),
  GroupID: z.number(),
});

export const sendMessageScheme = z.discriminatedUnion('Cmd', [
  sendChatMessageScheme,
  sendGroupChatMessageScheme,
  deleteChatMessageScheme,
  deleteGroupChatMessageScheme,
  z.object({
    Cmd: z.literal(SendMessageCommand.Login),
    UID: z.number(),
    Token: z.string(),
    Lang: z.string(),
    Gateway: z.string(),
    IsWeb: z.literal(true),
    D: z.number(),
    Brand: z.string().optional(),
  }),
  z.object({
    Cmd: z.literal(SendMessageCommand.Logout),
    UID: z.number(),
    Token: z.string(),
  }),
  z.object({
    Cmd: z.literal(SendMessageCommand.HeartBeat),
    UID: z.number(),
  }),
  z.object({
    Cmd: z.literal(SendMessageCommand.GroupUnsubscribe),
    UID: z.number(),
    GroupID: z.number(),
  }),
]);

export type SendMessageType = z.infer<typeof sendMessageScheme>;

export type SendChatMessageType = z.infer<typeof sendChatMessageScheme>;

export type SendGroupChatMessageType = z.infer<typeof sendGroupChatMessageScheme>;

export type DeleteChatMessageType = z.infer<typeof deleteChatMessageScheme>;

export type DeleteGroupChatMessageType = z.infer<typeof deleteGroupChatMessageScheme>;
